export default __webpack_public_path__ + "static/media/lidar-background.5be50aa6.jpg";